import { render } from "./IconImage.vue?vue&type=template&id=e4ab9042"
import script from "./IconImage.vue?vue&type=script&lang=js"
export * from "./IconImage.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/adriengeoorge.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__